// extracted by mini-css-extract-plugin
export default {"app":"App_app__gQuxZ","spinner":"App_spinner__7EV9M"};